import { ExperienceType } from '@/generated/graphql';
import { useAppSelector } from '@/store';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { ClickAwayListener, Grid, MenuList, Paper, useMediaQuery } from '@mui/material';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import { TimeFilter } from '../hooks/use-experience-filter';
import useSetTime from '../hooks/use-set-time';
import useType from '../hooks/use-type';
import StyledButton, {
  StyledButtonGroup,
  StyledGrow,
  StyledMenuItem,
  StyledPopper,
} from './dropdown-button';
const options = [
  TimeFilter.Today,
  TimeFilter.ThisWeek,
  TimeFilter.NextWeek,
  TimeFilter.ThisMonth,
  TimeFilter.NextMonth,
];
const NewTimeFilterButton = () => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const setTime = useSetTime();
  const isMonthEnding = useAppSelector(state => state.sections.exploreFilters.isMonthEnding);
  const isWeekEnding = useAppSelector(state => state.sections.exploreFilters.isWeekEnding);
  const type = useType();
  const isAvailable = type === ExperienceType.Schedule;
  const searchParams = useSearchParams();
  const time = searchParams?.get('time');
  const isMobile = useMediaQuery('(max-width: 960px');

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    if (options[index] === time) {
      setTime(undefined);
    } else {
      setTime(options[index]);
    }
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };
  const handleClick = () => {
    if (time) {
      setTime(undefined);
    } else {
      handleToggle();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const checkSelectedTime = () => {
    if (time === TimeFilter.Today) {
      return 'Today';
    } else if (time === TimeFilter.ThisWeek) {
      return 'This week';
    } else if (time === TimeFilter.NextWeek) {
      return 'Next week';
    } else if (time === TimeFilter.ThisMonth) {
      return 'This month';
    } else if (time === TimeFilter.NextMonth) {
      return 'Next month';
    } else {
      return isMobile ? 'Time' : 'Choose by date';
    }
  };
  const checkTime = () => {
    if (time) {
      return <CloseIcon style={{ color: 'black' }} />;
    }
    return <KeyboardArrowDown style={{ color: 'black' }} />;
  };
  const checkOption = (option: TimeFilter) => {
    if (option === TimeFilter.Today) {
      return 'Today';
    } else if (option === TimeFilter.ThisWeek) {
      return 'This week';
    } else if (option === TimeFilter.NextWeek) {
      return 'Next week';
    } else if (option === TimeFilter.ThisMonth) {
      return 'This month';
    } else if (option === TimeFilter.NextMonth) {
      return 'Next month';
    } else {
      return isMobile ? 'Time' : 'Choose by date';
    }
  };

  const selected = time !== undefined && time !== null;

  return (
    <Grid container direction="column" alignItems="center" style={{ width: 'auto' }}>
      <Grid item xs={12}>
        <StyledButtonGroup
          variant="contained"
          ref={anchorRef}
          className={selected ? 'selected' : ''}
        >
          <StyledButton onClick={handleClick}>
            {checkSelectedTime()}
            {checkTime()}
          </StyledButton>
        </StyledButtonGroup>
        <StyledPopper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps }) => (
            <StyledGrow {...TransitionProps}>
              <Paper style={{ width: 'max-content' }}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" style={{ paddingTop: 12, paddingBottom: 12 }}>
                    {options.map((option, index) => (
                      <StyledMenuItem
                        key={option}
                        selected={options[index] === time}
                        onClick={event => handleMenuItemClick(event, index)}
                        divider={index < options.length - 1}
                        disabled={
                          index === 0
                            ? isAvailable
                            : index === 1
                              ? isAvailable && isWeekEnding
                              : index === 3
                                ? isAvailable && isMonthEnding
                                : false
                        }
                      >
                        {checkOption(option)}
                      </StyledMenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </StyledGrow>
          )}
        </StyledPopper>
      </Grid>
    </Grid>
  );
};
export default NewTimeFilterButton;
